import { Component, type ErrorInfo, type ReactNode } from "react";
import { resetDemoEnvironment } from "../lib/demoApi";

type State = { failed: boolean };

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Precision EV interface recovery", error, info.componentStack);
  }

  private recover = () => {
    const demo = new URL(window.location.href).searchParams.get("demo") === "1" || window.location.pathname.replace(/\/+$/, "") === "/developer";
    if (demo) resetDemoEnvironment();
    window.location.reload();
  };

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="app-recovery-screen" role="alert">
      <section>
        <img src="./precision-logo-black.png" alt="Precision Autotechnik" />
        <h1>A aplicação encontrou um bloqueio.</h1>
        <p>O pedido pode já ter sido recebido. Reabra a aplicação para recuperar o ecrã sem voltar a enviar o formulário.</p>
        <button type="button" onClick={this.recover}>Reabrir a aplicação</button>
      </section>
    </main>;
  }
}
